import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { Checkbox, Form } from "antd";
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { IndustryInfo } from "../../../../types/course";
import { getIndustryFilter } from "../../../../service/courses";
import { MenuItem } from "../../../../types/sidebar";
import FilterStar from "../../../../components/filter/FilterStar";
import FilterPrice from "../../../../components/filter/FilterPrice";

export interface FilterProps {
  hasPaid?: boolean | undefined;
}
export const useFilters = ({ hasPaid = false }: FilterProps) => {
  const params = useParams();
  const university = params?.id || "";

  const [industriesFilterUniversity, setIndustriesFilterUniversity] = useState<
    IndustryInfo[]
  >([]);

  useEffect(() => {
    const getIndustriesFilterUniversity = async () => {
      const res = await getIndustryFilter({ universities: [university] });

      setIndustriesFilterUniversity(res.data.data);
    };
    getIndustriesFilterUniversity();
  }, []);

  const filterMenus: MenuItem[] = [
    {
      label: t("Chuyên ngành", "Chuyên ngành"),
      key: "industries",
      className: "course-filter-menu",
      children: industriesFilterUniversity?.map((item: IndustryInfo) => ({
        label: (
          <Form.Item name={`industry-${item?.code}`} valuePropName="checked">
            <Checkbox>
              {item?.name} {"("}
              {item?.count}
              {")"}
            </Checkbox>
          </Form.Item>
        ),
        key: `industry-${item?.code}`,
      })),
    },
    {
      label: t("Xếp hạng", "Xếp hạng"),
      key: "rank",
      children: [
        {
          label: (
            <Form.Item name="rank-5" valuePropName="checked">
              <Checkbox>
                <FilterStar star={5} />
              </Checkbox>
            </Form.Item>
          ),
          key: "rank-5",
        },
        {
          label: (
            <Form.Item name="rank-4" valuePropName="checked">
              <Checkbox>
                <FilterStar star={4} />
              </Checkbox>
            </Form.Item>
          ),
          key: "rank-4",
        },
        {
          label: (
            <Form.Item name="rank-3" valuePropName="checked">
              <Checkbox>
                <FilterStar star={3} />
              </Checkbox>
            </Form.Item>
          ),
          key: "rank-3",
        },
        {
          label: (
            <Form.Item name="rank-2" valuePropName="checked">
              <Checkbox>
                <FilterStar star={2} />
              </Checkbox>
            </Form.Item>
          ),
          key: "rank-2",
        },
        // {
        //   label: (
        //     <Form.Item name="rank-1" valuePropName="checked">
        //       <Checkbox>
        //         <FilterStar star={1.5} />
        //       </Checkbox>
        //     </Form.Item>
        //   ),
        //   key: "rank-1",
        // },
      ],
    },
    {
      label: t("Chi phí", "Chi phí"),
      key: "price",
      children: [
        {
          label: (
            <Form.Item name="price-free" valuePropName="checked">
              <Checkbox>{t("Miễn phí", "Miễn phí")}</Checkbox>
            </Form.Item>
          ),
          key: "price-free",
        },
        {
          label: (
            <div>
              <Form.Item name="price-paid" valuePropName="checked">
                <Checkbox>
                  <div>{t("Trả phí", "Trả phí")}</div>
                </Checkbox>
              </Form.Item>
              {hasPaid ? (
                <div className="pr-3 pl-1">
                  <FilterPrice />
                </div>
              ) : (
                ""
              )}
            </div>
          ),
          key: "price-paid",
        },
      ],
    },

    // {
    //   label: t("Trường", "Trường"),
    //   key: "university",
    //   className: "course-filter-menu",
    //   children: universities.map((item: UniversityInfo, index: number) => ({
    //     label: (
    //       <Form.Item name={`university-${item.uuid}-${index}`} valuePropName="checked">
    //         <Checkbox>
    //           <Tooltip title={item.name}><span className="one-line">{item.name}</span></Tooltip> {"("}
    //           {item.count}
    //           {")"}
    //         </Checkbox>
    //       </Form.Item>
    //     ),
    //     key: `university-${item.slug}-${index}`,
    //   })),
    // },

    {
      label: t("Loại khoá học", "Loại khoá học"),
      key: "kindOfCourse",
      children: [
        {
          label: (
            <Form.Item name="kindOfCourse-1" valuePropName="checked">
              <Checkbox>{t("Tự do ghi danh", "Tự do ghi danh")}</Checkbox>
            </Form.Item>
          ),
          key: "kindOfCourse-1",
        },
        {
          label: (
            <div>
              <Form.Item name="kindOfCourse-2" valuePropName="checked">
                <Checkbox>
                  <div>{t("Thẻ ghi danh", "Thẻ ghi danh")}</div>
                </Checkbox>
              </Form.Item>
            </div>
          ),
          key: "kindOfCourse-2",
        },
      ],
    },
  ];

  return filterMenus;
};
